import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { DeleteMySettlement } from 'services/fund/settlement'

export default function useDeleteSettlement(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: number) => {
            return DeleteMySettlement(payload)
        },
        onSuccess: (_, variables) => {
            toast.success('درخواست با موفقیت حذف شد')
            refetch()
        },
        onError: () => {
            toast.error('مشکلی در حذف درخواست پیش آمده')
        },
    })
    return { isLoading, mutate }
}
